import type { VoxnelaTaskItem } from './voxnela56Tasks'
import { SEARCH_CONCEPT_TRANSLATIONS } from './styleSearchI18n'

interface SearchConcept {
  id: string
  aliases: string[]
}

const CONCEPTS: SearchConcept[] = [
  { id: 'cinematic', aliases: ['sinematik', 'sinema', 'film karesi', 'movie still', 'cinematic', 'anamorfik', 'anamorphic'] },
  { id: 'portrait', aliases: ['portre', 'portrait', 'headshot', 'profil fotografi', 'profile photo'] },
  { id: 'fashion', aliases: ['moda', 'fashion', 'vogue', 'haute couture', 'podyum', 'runway', 'giyim', 'kiyafet', 'outfit', 'wardrobe'] },
  { id: 'editorial', aliases: ['editoryal', 'editorial', 'dergi', 'magazine', 'gazete', 'newspaper', 'yayin', 'publication'] },
  { id: 'poster', aliases: ['afis', 'poster', 'duyuru', 'announcement', 'etkinlik ilani', 'event poster'] },
  { id: 'business', aliases: ['is dunyasi', 'business', 'kurumsal', 'corporate', 'yonetici', 'executive'] },
  { id: 'report', aliases: ['rapor', 'report', 'sunum', 'presentation', 'pitch deck', 'slayt', 'slide'] },
  { id: 'data', aliases: ['veri', 'data', 'kpi', 'istatistik', 'statistics', 'grafik', 'chart', 'infografik', 'infographic', 'analitik', 'analytics'] },
  { id: 'analysis', aliases: ['analiz', 'analysis', 'yorum', 'degerlendirme', 'review', 'inceleme', 'audit'] },
  { id: 'marketing', aliases: ['pazarlama', 'marketing', 'kampanya', 'campaign', 'reklam', 'advertising', 'sosyal medya', 'social media'] },
  { id: 'product', aliases: ['urun', 'product', 'ambalaj', 'packaging', 'e ticaret', 'ecommerce', 'ticari', 'commercial'] },
  { id: 'interior', aliases: ['oda', 'room', 'ic mekan', 'interior', 'dekorasyon', 'decoration', 'mobilya', 'furniture', 'ev ofisi', 'home office'] },
  { id: 'architecture', aliases: ['mimari', 'architecture', 'architectural', 'brutalist', 'brutalizm', 'bina', 'building', 'mekan', 'space'] },
  { id: 'perspective', aliases: ['derin perspektif', 'deep perspective', 'perspektif', 'perspective', 'kacis noktasi', 'vanishing point', 'genis aci', 'wide angle'] },
  { id: 'travel', aliases: ['seyahat', 'travel', 'gezi', 'trip', 'yolculuk', 'journey', 'rota', 'route', 'tatil', 'vacation'] },
  { id: 'weather', aliases: ['hava durumu', 'weather', 'forecast', 'tahmin', 'yagmur', 'rain', 'kar', 'snow', 'ruzgar', 'wind'] },
  { id: 'historical', aliases: ['tarihi', 'historical', 'donem', 'period', 'zaman yolculugu', 'time travel', 'antik', 'ancient', 'ronesans', 'renaissance', 'vintage era'] },
  { id: 'city', aliases: ['sehir', 'city', 'kent', 'urban', 'sokak', 'street', 'metropol', 'skyline', 'silüet', 'siluet'] },
  { id: 'nature', aliases: ['doga', 'nature', 'orman', 'forest', 'okyanus', 'ocean', 'deniz', 'sea', 'cicek', 'floral', 'botanical', 'col', 'desert'] },
  { id: 'dark', aliases: ['karanlik', 'dark', 'noir', 'kasvetli', 'moody', 'gizemli', 'mysterious', 'golge', 'shadow', 'chiaroscuro'] },
  { id: 'bright', aliases: ['aydinlik', 'bright', 'ferah', 'airy', 'isikli', 'luminous', 'pastel', 'soft light'] },
  { id: 'colorful', aliases: ['renkli', 'colorful', 'colourful', 'canli renk', 'vibrant', 'pop', 'doygun', 'saturated'] },
  { id: 'monochrome', aliases: ['siyah beyaz', 'black and white', 'black white', 'monochrome', 'monokrom', 'grayscale'] },
  { id: 'minimal', aliases: ['minimal', 'minimalist', 'sade', 'clean', 'sessiz luks', 'quiet luxury', 'negatif alan', 'negative space'] },
  { id: 'luxury', aliases: ['luks', 'luxury', 'premium', 'seckin', 'opulent', 'zarif', 'elegant', 'sofistike', 'sophisticated'] },
  { id: 'surreal', aliases: ['surreal', 'surrealist', 'gercekustu', 'ruya', 'dreamlike', 'fantastik', 'fantasy', 'imkansiz', 'impossible'] },
  { id: 'futuristic', aliases: ['futuristik', 'futuristic', 'gelecek', 'future', 'siber', 'cyber', 'cyberpunk', 'bilim kurgu', 'science fiction', 'sci fi'] },
  { id: 'future', aliases: ['sonraki yillar', 'next years', 'future self', 'yaslanma', 'age progression'] },
  { id: 'retro', aliases: ['retro', 'nostaljik', 'nostalgic', 'vintage', 'eski tarz', 'old school'] },
  { id: 'analog', aliases: ['analog', 'analogue', '35mm', 'film greni', 'film grain', 'kodak', 'portra', 'leica', 'darkroom'] },
  { id: 'three-d', aliases: ['3d', 'uc boyutlu', 'three dimensional', 'diorama', 'minyatur', 'miniature', 'izometrik', 'isometric', 'maket'] },
  { id: 'photoreal', aliases: ['fotogercekci', 'photorealistic', 'gercekci', 'realistic', 'gercek fotograf', 'real photo', 'hyperreal', 'hipergercekci'] },
  { id: 'illustration', aliases: ['illüstrasyon', 'illustration', 'cizim', 'drawing', 'boyama', 'painting', 'grafit', 'graphite', 'suluboya', 'watercolor'] },
  { id: 'collage', aliases: ['kolaj', 'collage', 'scrapbook', 'mixed media', 'karisik teknik', 'kes yapistir'] },
  { id: 'print', aliases: ['baski', 'print', 'risograph', 'riso', 'serigrafi', 'screen print', 'halftone', 'zine', 'fanzin', 'xerox'] },
  { id: 'glitch', aliases: ['glitch', 'rgb', 'datamosh', 'dijital bozulma', 'digital distortion', 'kromatik', 'chromatic aberration'] },
  { id: 'glass', aliases: ['cam', 'glass', 'kristal', 'crystal', 'refraksiyon', 'refraction', 'prizmatik', 'prismatic'] },
  { id: 'metal', aliases: ['krom', 'chrome', 'metal', 'metallic', 'celik', 'steel', 'civa', 'mercury'] },
  { id: 'organic', aliases: ['organik', 'organic', 'akiskan', 'fluid', 'ipek', 'silk', 'dogal doku', 'natural texture'] },
  { id: 'face-analysis', aliases: ['yuz analizi', 'face analysis', 'yuz hatlari', 'facial features', 'sac stili', 'hair style', 'sakal', 'beard', 'gozluk', 'eyewear'] },
  { id: 'outfit-analysis', aliases: ['kiyafet analizi', 'outfit analysis', 'kombin', 'look analysis', 'gardrop', 'wardrobe review'] },
  { id: 'food', aliases: ['yemek', 'food', 'gastronomi', 'gastronomy', 'tabak', 'plating', 'tarif', 'recipe', 'mutfak', 'cuisine'] },
  { id: 'music', aliases: ['muzik', 'music', 'konser', 'concert', 'caz', 'jazz', 'festival', 'album', 'ses', 'sound'] },
  { id: 'theatre', aliases: ['tiyatro', 'theatre', 'theater', 'sahne', 'stage', 'opera', 'bale', 'ballet', 'performans', 'performance'] },
  { id: 'event', aliases: ['etkinlik', 'event', 'duyuru', 'announcement', 'davet', 'invitation', 'gala', 'konferans', 'conference', 'zirve', 'summit'] },
  { id: 'typography', aliases: ['tipografi', 'typography', 'yazi', 'lettering', 'manset', 'headline', 'metin', 'text layout'] },
  { id: 'sports', aliases: ['spor', 'sports', 'mac', 'match', 'turnuva', 'tournament', 'futbol', 'football', 'basketbol', 'basketball'] },
  { id: 'family', aliases: ['aile', 'family', 'ani', 'memory', 'hatira', 'heritage', 'arsiv', 'archive'] },
  { id: 'identity-preserving', aliases: ['beni yerlestir', 'put me', 'kendi fotografim', 'my photo', 'yuzumu koru', 'preserve face', 'kimligi koru', 'identity preserve'] },
]

for (const translations of Object.values(SEARCH_CONCEPT_TRANSLATIONS)) {
  for (const [id, value] of Object.entries(translations)) {
    const concept = CONCEPTS.find((entry) => entry.id === id)
    if (concept) concept.aliases.push(...value.split('|'))
  }
}

const CATEGORY_TAGS: Record<VoxnelaTaskItem['category'], string[]> = {
  voxnela: ['Voxnela imza', 'özel sanat yönetimi', 'premium konsept'],
  business: ['iş', 'rapor', 'kurumsal', 'sunum', 'veri'],
  product: ['ürün', 'reklam', 'pazarlama', 'kampanya', 'sosyal medya', 'ticari çekim', 'ambalaj'],
  stylize: ['stil transferi', 'portre', 'sanat fotoğrafı', 'görsel estetik'],
  creative: ['kreatif', 'sanat', 'illüstrasyon', 'deneysel'],
  time_traveler: ['zaman yolculuğu', 'tarihsel dönem', 'kimlik koruma'],
  poster: ['afiş', 'poster', 'etkinlik', 'duyuru'],
  editorial: ['editoryal', 'dergi', 'gazete', 'yayın tasarımı'],
}

const STYLE_TAG_OVERRIDES: Record<string, string[]> = {
  creative_comic_story: ['comic story', 'comic strip', 'story to comic', 'comic book', 'çizgi roman', 'çizgi roman hikâyesi', 'hikâyeyi çizgi romana çevir', 'graphic novel', 'four panel comic', 'four-panel comic', 'storyboard comic'],
  editorial_fashion_cover: ['premium fashion editorial magazine cover', 'luxury fashion publication', 'Vogue-style cover'],
  voxnela_weather_skyline: ['hava durumu', 'şehir silüeti', '3D minyatür', 'weather poster', 'forecast'],
  voxnela_road_trip_atlas: ['road trip', 'gezi planı', 'rota', 'seyahat programı', 'travel itinerary'],
  voxnela_city_day_compass: ['şehir rehberi', 'günlük gezi planı', 'city guide', 'walking route'],
  voxnela_face_style_analysis: ['yüz analizi', 'saç ve sakal', 'gözlük', 'portre yönlendirmesi', 'face style atlas'],
  voxnela_combin_analysis: ['kombin analizi', 'kıyafet yorumu', 'giyim önerisi', 'outfit analysis', 'wardrobe styling'],
  voxnela_next_years: ['next years', 'sonraki yıllar', 'gelecekteki halim', '15 yıl sonra', 'yaş ilerlemesi', 'future self'],
  voxnela_outfit_analysis: ['kıyafet analizi', 'kombin', 'renk uyumu', 'silüet', 'outfit review'],
  voxnela_clothing_tryon: ['kıyafet dene', 'kıyafet deneme', 'üstümde dene', 'sanal prova', 'sanal giyinme', 'try on clothes', 'virtual try-on', 'outfit try on', 'clothing try-on'],
  voxnela_room_analysis: ['oda analizi', 'iç mekân', 'dekorasyon', 'mobilya yerleşimi', 'room redesign'],
  voxnela_home_office_analysis: ['çalışma odası', 'ev ofisi', 'masa düzeni', 'aydınlatma', 'workspace analysis'],
  voxnela_balcony_garden_analysis: ['balkon', 'bahçe', 'bitki düzeni', 'peyzaj', 'garden design'],
  voxnela_food_plating_analysis: ['tabak sunumu', 'yemek analizi', 'gastronomi', 'food plating'],
  voxnela_packaging_analysis: ['ambalaj analizi', 'paket tasarımı', 'ürün rafı', 'packaging review'],
  voxnela_retail_display_analysis: ['mağaza vitrini', 'perakende', 'ürün sergileme', 'retail display'],
  voxnela_profile_photo_analysis: ['profil fotoğrafı', 'headshot', 'portre ışığı', 'kadraj analizi'],
  voxnela_luggage_analysis: ['valiz', 'seyahat hazırlığı', 'kıyafet planı', 'packing analysis'],
}

const STOP_WORDS = new Set([
  'bir', 've', 'veya', 'ile', 'icin', 'gibi', 'olan', 'olsun', 'istiyorum', 'yap', 'bana', 'daha', 'cok',
  'the', 'and', 'or', 'with', 'for', 'style', 'make', 'create', 'want', 'show', 'image', 'visual',
])

export function normalizeStyleSearchText(value: string): string {
  return value
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .replace(/ş/g, 's')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\p{L}\p{M}\p{N}]+/gu, ' ')
    .trim()
}

function containsAlias(text: string, alias: string): boolean {
  const normalizedAlias = normalizeStyleSearchText(alias)
  return normalizedAlias.includes(' ')
    ? (` ${text} `).includes(` ${normalizedAlias} `)
    : (` ${text} `).includes(` ${normalizedAlias} `) || (/[^\x00-\x7F]/.test(normalizedAlias) && text.includes(normalizedAlias))
}

function conceptsForText(text: string): Set<string> {
  const normalized = normalizeStyleSearchText(text)
  return new Set(
    CONCEPTS
      .filter((concept) => concept.aliases.some((alias) => containsAlias(normalized, alias)))
      .map((concept) => concept.id),
  )
}

export function buildStyleSearchTags(item: VoxnelaTaskItem, categoryLabel = ''): string[] {
  const source = [
    item.id.replace(/[_-]/g, ' '),
    item.title,
    item.shortTitle,
    item.badge,
    item.description,
    ...(item.searchTags || []),
  ].join(' ')
  const detectedConcepts = conceptsForText(source)
  const conceptTags = CONCEPTS
    .filter((concept) => detectedConcepts.has(concept.id))
    .flatMap((concept) => concept.aliases)

  const tags = [
    categoryLabel,
    ...CATEGORY_TAGS[item.category],
    ...(item.searchTags || []),
    ...(STYLE_TAG_OVERRIDES[item.id] || []),
    ...conceptTags,
  ].filter((tag): tag is string => Boolean(tag))

  return Array.from(new Set(tags))
}

export interface StyleSearchResult {
  item: VoxnelaTaskItem
  score: number
}

interface IndexedStyle {
  title: string
  badge: string
  tags: string
  description: string
  allText: string
  concepts: Set<string>
}

interface PreparedQuery {
  normalized: string
  terms: string[]
  concepts: Set<string>
}

const STYLE_INDEX_CACHE = new WeakMap<VoxnelaTaskItem, Map<string, IndexedStyle>>()
const QUERY_CACHE = new Map<string, PreparedQuery>()

function getIndexedStyle(item: VoxnelaTaskItem, categoryLabel: string): IndexedStyle {
  let categoryIndexes = STYLE_INDEX_CACHE.get(item)
  if (!categoryIndexes) {
    categoryIndexes = new Map<string, IndexedStyle>()
    STYLE_INDEX_CACHE.set(item, categoryIndexes)
  }

  const cached = categoryIndexes.get(categoryLabel)
  if (cached) return cached

  const title = normalizeStyleSearchText(`${item.title} ${item.shortTitle}`)
  const badge = normalizeStyleSearchText(item.badge)
  const tags = normalizeStyleSearchText(`${categoryLabel} ${(item.searchTags || []).join(' ')}`)
  const description = normalizeStyleSearchText(item.description)
  const allText = `${title} ${badge} ${tags} ${description}`
  const indexed = { title, badge, tags, description, allText, concepts: conceptsForText(allText) }
  categoryIndexes.set(categoryLabel, indexed)
  return indexed
}

function prepareQuery(query: string): PreparedQuery {
  const cached = QUERY_CACHE.get(query)
  if (cached) return cached

  const normalized = normalizeStyleSearchText(query)
  const prepared = {
    normalized,
    terms: normalized.split(/\s+/).filter((term) => (term.length > 1 || /[^\x00-\x7F]/.test(term)) && !STOP_WORDS.has(term)),
    concepts: conceptsForText(normalized),
  }

  if (QUERY_CACHE.size > 40) QUERY_CACHE.clear()
  QUERY_CACHE.set(query, prepared)
  return prepared
}

export function scoreStyleSearch(item: VoxnelaTaskItem, query: string, categoryLabel = ''): number {
  const preparedQuery = prepareQuery(query)
  const normalizedQuery = preparedQuery.normalized
  if (!normalizedQuery) return 1

  const terms = preparedQuery.terms
  if (!terms.length) return 1

  const { title, badge, tags, description, allText, concepts: itemConcepts } = getIndexedStyle(item, categoryLabel)
  const queryConcepts = preparedQuery.concepts
  const requestedAnalysis = ['face-analysis', 'outfit-analysis'].filter((concept) => queryConcepts.has(concept))
  if (requestedAnalysis.length > 0 && !requestedAnalysis.some((concept) => itemConcepts.has(concept))) return 0

  let score = 0
  let matchedTerms = 0
  for (const term of terms) {
    let termScore = 0
    const includesTerm = (value: string) => (` ${value} `).includes(` ${term} `) || (/[^\x00-\x7F]/.test(term) && value.includes(term))
    if (includesTerm(title)) termScore = Math.max(termScore, 18)
    if (includesTerm(badge)) termScore = Math.max(termScore, 14)
    if (includesTerm(tags)) termScore = Math.max(termScore, 13)
    if (includesTerm(description)) termScore = Math.max(termScore, 8)
    if (
      !termScore
      && term.length >= 4
      && allText.split(' ').some((word) => word.startsWith(term) || (word.length >= 4 && term.startsWith(word)))
    ) termScore = 4
    if (termScore) {
      score += termScore
      matchedTerms += 1
    }
  }

  let conceptMatches = 0
  queryConcepts.forEach((concept) => {
    if (itemConcepts.has(concept)) conceptMatches += 1
  })
  score += conceptMatches * 20
  if (queryConcepts.has('fashion') && itemConcepts.has('outfit-analysis')) score += 32

  if (title.includes(normalizedQuery)) score += 36
  else if (tags.includes(normalizedQuery)) score += 28
  else if (description.includes(normalizedQuery)) score += 16

  if (matchedTerms === 0 && conceptMatches === 0) return 0

  const coverage = Math.max(matchedTerms, conceptMatches) / Math.max(terms.length, queryConcepts.size, 1)
  return Math.round(score * (0.68 + Math.min(coverage, 1) * 0.32))
}

export function searchAndRankStyles(
  items: VoxnelaTaskItem[],
  query: string,
  categoryLabel = '',
): StyleSearchResult[] {
  if (!normalizeStyleSearchText(query)) return items.map((item) => ({ item, score: 1 }))
  return items
    .map((item) => ({ item, score: scoreStyleSearch(item, query, categoryLabel) }))
    .filter((result) => result.score >= 10)
    .sort((a, b) => b.score - a.score || a.item.title.localeCompare(b.item.title, 'tr'))
}
